import React from "react";
import { Button, MobileStepper } from "@material-ui/core";
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { useTranslation } from "react-i18next";

export const RepLIMobileStepper = props => {
    const { t } = useTranslation();

    const ExitButton = props => (
        <StepperButton onClick={props.onClick}>
            <KeyboardArrowLeft />{t('common.form.stepper.button.exit')}
        </StepperButton>
    );
    const BackButton = props => (
        <StepperButton onClick={props.onClick}>
            <KeyboardArrowLeft />{t('common.form.stepper.button.back')}
        </StepperButton>
    );
    const NextButton = props => (
        <StepperButton onClick={props.onClick}>
            {t('common.form.stepper.button.next')}<KeyboardArrowRight />
        </StepperButton>
    );
    const FinishButton = props => (
        <StepperButton onClick={props.onClick}>
            {t('common.form.stepper.button.finish')}&nbsp;&nbsp;&nbsp;&nbsp;
        </StepperButton>
    );
    const StepperButton = ({ onClick, ...rest }) => (
        <Button color="secondary" size="large" onClick={onClick} {...rest}>
            {rest.children}
        </Button>
    );

    return (
        <MobileStepper
            variant="dots"
            steps={props.steps}
            position="static"
            activeStep={props.activeStep}
            nextButton={
                props.activeStep !== props.steps - 1
                    ? <NextButton onClick={props.onNextButtonClick} />
                    : <FinishButton onClick={props.onFinishButtonClick} />
            }
            backButton={
                props.activeStep !== 0
                    ? <BackButton onClick={props.onBackButtonClick} />
                    : <ExitButton onClick={props.onExitButtonClick} />
            }
        />
    )
};